import styled from "styled-components";
import Row from "../../Kit/Row";

export const MenuWrapper = styled(Row)`
    justify-content: center;
`
export const MenuItem = styled.a`
    width: auto;
    margin: 0 20px;
    font-size: ${(props) => props.theme.fontSizeSm};
    cursor: pointer;
    ::after {
        content: "";
        display: flex;
        width: 100%;
        height: 3px;
        background-color: ${(props) => props.isActive ? props.theme.secondary : "transparent"};
        border-radius: 1.5px;
        transition: all 300ms;
    }
    /* @media screen and (max-width: 1366px) {
        margin: 0 15px;
        font-size: 15px;
    } */
`